import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1da08fd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "goods-top-tips-box" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "选择商品", -1))
const _hoisted_3 = { class: "goods-info-box" }
const _hoisted_4 = { class: "goods-image-box" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "goods-name-box" }
const _hoisted_7 = {
  key: 0,
  class: "goods-sku-box"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "inner-card-box" }
const _hoisted_10 = { class: "inner-card-right" }
const _hoisted_11 = {
  key: 0,
  class: "express-info-box"
}
const _hoisted_12 = { class: "express-row-box" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "物流公司：", -1))
const _hoisted_14 = { class: "express-row-box" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "是否叫快递：", -1))
const _hoisted_16 = {
  key: 0,
  class: "express-row-box"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "物流单号：", -1))
const _hoisted_18 = {
  key: 1,
  class: "express-row-box"
}
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, null, -1))
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-box" }, "提交后系统会向快递公司下单，运单号由系统自动生成并回填到包裹上", -1))
const _hoisted_21 = [
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = {
  key: 0,
  class: "person-cols-box"
}
const _hoisted_23 = { class: "inner-card-box" }
const _hoisted_24 = { class: "inner-card-left" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "发货人信息", -1))
const _hoisted_26 = { class: "head-warehouse-box" }
const _hoisted_27 = {
  key: 0,
  class: "head-default-tag-box"
}
const _hoisted_28 = { class: "inner-card-right" }
const _hoisted_29 = { class: "person-row-box" }
const _hoisted_30 = { class: "express-row-box" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "发货人：", -1))
const _hoisted_32 = { class: "express-row-box" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "手机号：", -1))
const _hoisted_34 = { class: "person-row-box" }
const _hoisted_35 = { class: "express-row-box area-cell-box" }
const _hoisted_36 = { class: "express-row-box" }
const _hoisted_37 = {
  key: 0,
  class: "tips-box"
}
const _hoisted_38 = {
  key: 1,
  class: "tips-box"
}
const _hoisted_39 = { class: "inner-card-box" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "inner-card-left" }, "收货人信息", -1))
const _hoisted_41 = { class: "inner-card-right" }
const _hoisted_42 = { class: "person-row-box" }
const _hoisted_43 = { class: "express-row-box" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "收货人：", -1))
const _hoisted_45 = { class: "express-row-box" }
const _hoisted_46 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "express-title-box" }, "手机号：", -1))
const _hoisted_47 = { class: "person-row-box" }
const _hoisted_48 = { class: "express-row-box area-cell-box" }
const _hoisted_49 = { class: "express-row-box" }
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips-box" }, "默认取订单上的收货信息，可以按实际情况修改", -1))
const _hoisted_51 = { class: "align-right-box" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_dialog_title = _resolveComponent("ui-dialog-title")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_ui_table = _resolveComponent("ui-table")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_ui_area_select = _resolveComponent("ui-area-select")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ui_form_item = _resolveComponent("ui-form-item")!
  const _component_ui_form = _resolveComponent("ui-form")!
  const _component_ui_dialog_container = _resolveComponent("ui-dialog-container")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_ui_dialog_container, null, {
    header: _withCtx(() => [
      _createVNode(_component_ui_dialog_title, {
        onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('reject'))),
        title: "订单发货"
      })
    ]),
    default: _withCtx(() => [
      _createVNode(_component_ui_form, {
        style: {"padding":"20px"},
        model: _ctx.ruleForm,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _hoisted_2,
            _createTextVNode("待发货 " + _toDisplayString(_ctx.goodsInfo.waitSend) + " 件，已发货 " + _toDisplayString(_ctx.goodsInfo.send) + " 件 ", 1)
          ]),
          _createVNode(_component_ui_table, {
            data: _ctx.orderInfo.orderGoods,
            style: {"margin-top":"10px"}
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, null, {
                header: _withCtx(() => [
                  _createVNode(_component_el_checkbox, {
                    class: "name-check-box",
                    modelValue: _ctx.checkAll,
                    indeterminate: _ctx.checkIndeter,
                    onInput: _ctx.checkAllGoods
                  }, null, 8, ["modelValue", "indeterminate", "onInput"]),
                  _createTextVNode(" 商品 ")
                ]),
                default: _withCtx(({ row }) => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_component_el_checkbox, {
                      class: "goods-check-box",
                      disabled: _ctx.remainNum(row) <= 0,
                      modelValue: !!_ctx.getSendItem(row.id),
                      onInput: ($event: any) => (_ctx.changeGoods(row))
                    }, null, 8, ["disabled", "modelValue", "onInput"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("img", {
                        src: row.goodsDetails.cover
                      }, null, 8, _hoisted_5)
                    ]),
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("div", null, _toDisplayString(row.goodsDetails.name), 1),
                      (row.goodsDetails.skuName)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(row.goodsDetails.skuName), 1))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                prop: "num",
                width: "90",
                label: "购买数量",
                align: "center"
              }),
              _createVNode(_component_el_table_column, {
                label: "已发货",
                width: "80",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(row.sendNumber || 0), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "本次发货",
                width: "180",
                align: "center"
              }, {
                default: _withCtx(({ row }) => [
                  (_ctx.getSendItem(row.id))
                    ? (_openBlock(), _createBlock(_component_el_input_number, {
                        key: 0,
                        "model-value": _ctx.getSendItem(row.id).num,
                        min: 1,
                        max: _ctx.remainNum(row),
                        size: "small",
                        onChange: (val) => _ctx.setSendNum(row.id, val)
                      }, null, 8, ["model-value", "max", "onChange"]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_8, "-"))
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "状态",
                width: "100"
              }, {
                default: _withCtx(({ row }) => [
                  _createTextVNode(_toDisplayString(_ctx.statusText(row)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", null, [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.ruleForm.type,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.ruleForm.type) = $event))
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sendList, (item) => {
                      return (_openBlock(), _createBlock(_component_el_radio, {
                        label: item.value,
                        key: item.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              (_ctx.ruleForm.type == 1)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _hoisted_13,
                      _createVNode(_component_el_select, {
                        class: "select-box",
                        modelValue: _ctx.ruleForm.expressId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.ruleForm.expressId) = $event)),
                        filterable: "",
                        placeholder: "请选择物流公司"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressList.list, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.id,
                              label: item.name,
                              value: item.id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _hoisted_15,
                      _createVNode(_component_el_radio_group, {
                        modelValue: _ctx.ruleForm.isCallExpress,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.ruleForm.isCallExpress) = $event))
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_radio, { label: false }, {
                            default: _withCtx(() => [
                              _createTextVNode("不叫快递")
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_radio, { label: true }, {
                            default: _withCtx(() => [
                              _createTextVNode("叫快递")
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    (!_ctx.ruleForm.isCallExpress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                          _hoisted_17,
                          _createVNode(_component_el_input, {
                            modelValue: _ctx.ruleForm.expressBill,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.ruleForm.expressBill) = $event)),
                            placeholder: "请输入物流单号"
                          }, null, 8, ["modelValue"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, _hoisted_21))
                  ]))
                : _createCommentVNode("", true)
            ])
          ]),
          (_ctx.ruleForm.type == 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    (_ctx.warehouseList.length)
                      ? (_openBlock(), _createBlock(_component_el_dropdown, {
                          key: 0,
                          trigger: "click",
                          onCommand: _ctx.applyWarehouse
                        }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.warehouseList, (item) => {
                                  return (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                    key: item.id,
                                    command: item.id,
                                    class: _normalizeClass({ 'head-current-item-box': item.id == _ctx.warehouseId })
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(item.name) + " ", 1),
                                      (item.isDefault)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, "默认"))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _: 2
                                  }, 1032, ["command", "class"]))
                                }), 128))
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_26, [
                              _createTextVNode(" 切换仓库 "),
                              _createVNode(_component_el_icon, { class: "head-caret-box" }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ArrowDown)
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          _: 1
                        }, 8, ["onCommand"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _hoisted_31,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.senderForm.name,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.senderForm.name) = $event)),
                          placeholder: "请输入发货人姓名"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_32, [
                        _hoisted_33,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.senderForm.mobile,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.senderForm.mobile) = $event)),
                          placeholder: "请输入发货人手机号"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", _hoisted_35, [
                        _createVNode(_component_ui_area_select, {
                          modelValue: _ctx.senderArea,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.senderArea) = $event)),
                          placeholder: "请选择发货地区"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.senderForm.address,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.senderForm.address) = $event)),
                          placeholder: "请输入详细地址"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    (_ctx.warehouse)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createTextVNode(" 默认取所选仓库，可以手动修改； "),
                          _createVNode(_component_el_link, {
                            type: "primary",
                            underline: false,
                            onClick: _ctx.gotoWarehouse
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("修改仓库")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                          _createTextVNode(" 没有发货仓库，先手动填写； "),
                          _createVNode(_component_el_link, {
                            type: "primary",
                            underline: false,
                            onClick: _ctx.gotoWarehouse
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("去添加仓库")
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]))
                  ])
                ]),
                _createElementVNode("div", _hoisted_39, [
                  _hoisted_40,
                  _createElementVNode("div", _hoisted_41, [
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.receiverForm.name,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.receiverForm.name) = $event)),
                          placeholder: "请输入收货人姓名"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_45, [
                        _hoisted_46,
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.receiverForm.mobile,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.receiverForm.mobile) = $event)),
                          placeholder: "请输入收货人手机号"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_47, [
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_ui_area_select, {
                          modelValue: _ctx.receiverArea,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.receiverArea) = $event)),
                          placeholder: "请选择收货地区"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_49, [
                        _createVNode(_component_el_input, {
                          modelValue: _ctx.receiverForm.address,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.receiverForm.address) = $event)),
                          placeholder: "请输入详细地址"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _hoisted_50
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(_component_ui_form_item, { style: {"margin":"0"} }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_51, [
                _withDirectives((_openBlock(), _createBlock(_component_el_button, {
                  type: "primary",
                  onClick: _ctx.submitForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("发货")
                  ]),
                  _: 1
                }, 8, ["onClick"])), [
                  [_directive_loading, _ctx.submitLoading]
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _: 1
  }))
}